import React, { Component, Fragment } from 'react';
import moment from 'moment';
import 'react-datetime/css/react-datetime.css';
import { Row, Col, Label, Input, InputGroup, FormFeedback } from 'reactstrap';

import api from '../../../api/';
import Create from "./Create.js"
import Edit from "./Edit.js"
import Delete from "./Delete.js"
import Detail from "./Detail.js"
import ParadigmaAsyncSeeker from "../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js"
import ParadigmaLabeledInput from "../../../components/ParadigmaLabeledInput/ParadigmaLabeledInput.js"
import ParadigmaTable from "../../../components/ParadigmaTable/"
import ParadigmaDatePicker from "../../../components/ParadigmaDatePicker/ParadigmaDatePicker"
import DateFilter from "../../../components/ParadigmaTable/DateFilter";
import CurrencyInput from "../../../components/ParadigmaCurrencyInput/ParadigmaCurrencyInput.js"
import dateFunctions from '../../functions/dateFunctions';
import { formatCurrency } from './../../functions/dateFunctions.js'

class Contactos extends Component {
    constructor() {
        super();
        const fechaInicio = moment().startOf('month');
        const fechaFin = moment().endOf('month');

        this.state = {
            cuentaCorriente: null,
            unidadVinculacionTecnologica: null,
            fechaInicio,
            fechaFin,
            saldosUVT: [],
            filter: this.getDateFilter(fechaInicio, fechaFin),
        };
    }

    getDateFilter(fechaInicio, fechaFin) {
        let filter = [];

        const startMoment = moment(fechaInicio);
        const endMoment = moment(fechaFin);

        if (startMoment.isValid() && endMoment.isValid()) {
            filter.push({
                'id': 'fecha',
                'value': {
                    input: startMoment.format('YYYY-MM-DD'),
                    lookup: "date__gte"
                }
            });

            filter.push({
                'id': 'fecha',
                'value': {
                    input: endMoment.format('YYYY-MM-DD'),
                    lookup: "date__lte"
                }
            });
        }

        return filter;
    }

    onChangeCuentaCorriente = (cuentaCorriente) => {
        this.setState({ cuentaCorriente });
    }

    onChangeUnidadVinculacionTecnologica = (unidadVinculacionTecnologica) => {
        this.setState({ unidadVinculacionTecnologica });
    }

    onFechaChange(fechaInicio, fechaFin) {
        this.setState({
            fechaInicio: moment(fechaInicio),
            fechaFin: moment(fechaFin),
            filter: this.getDateFilter(fechaInicio, fechaFin),
        });
    }

    setComponents = (data) => {
        const saldosUVT = data.metadata && data.metadata.saldos_uvt ? data.metadata.saldos_uvt : [];

        this.setState({
            saldosUVT,
        });
    }

    render() {
        const {
            cuentaCorriente,
            unidadVinculacionTecnologica,
            fechaInicio,
            fechaFin,
            saldosUVT,
        } = this.state

        const columns = [
            {
                Header: "id",
                id: "pk",
                accessor: "pk",
                width: 100,
                show: false,
                private: true,
                filterable: false,
            },
            {
                Header: "Fecha",
                id: "fecha",
                accessor: d => dateFunctions.parseDate(d.fecha),
                show: true,
                width: 150,
                filterable: false,
            },
            {
                Header: "Categoria",
                id: "categoria_nombre",
                accessor: d => d.categoria_nombre,
                show: true,
                filterable: false,
            },
            {
                Header: "UVT",
                id: "unidad_vinculacion_tecnologica_nombre",
                accessor: d => d.unidad_vinculacion_tecnologica_nombre,
                show: true,
                filterable: false,
            },
            {
                Header: "Factura",
                id: "factura",
                accessor: d => d.factura,
                show: true,
                filterable: false,
            },
            {
                Header: "Descripción",
                id: "descripcion",
                accessor: d => d.descripcion,
                show: true,
                filterable: false,
            },
            {
                Header: "Ingreso ($)",
                id: "ingreso_monto",
                accessor: d => formatCurrency(d.ingreso_monto),
                show: true,
                filterable: false,
            },
            {
                Header: "Egreso ($)",
                id: "egreso_monto",
                accessor: d => formatCurrency(d.egreso_monto),
                show: true,
                filterable: false,
            },
            {
                Header: "Saldo ($)",
                id: "saldo",
                accessor: d => formatCurrency(d.saldo),
                show: true,
                filterable: false,
            },
        ]

        const buttons=[
            {
                create: true,
                permission: 'saldos_movimientos_add',
                component: Create,
            },
            {
                detail: true,
                permission: 'saldos_movimientos_detail',
                component: Detail,
            },
            {
                edit: true,
                permission: 'saldos_movimientos_edit',
                component: Edit,
            },
            {
                edit: true,
                permission: 'saldos_movimientos_delete',
                component: Delete,
            }
        ]

        var filters = []

        if (fechaInicio.isValid() && fechaFin.isValid()) {
            filters.push({
                'id': 'fecha_inicio',
                'value': {
                    input: fechaInicio.format('YYYY-MM-DD'),
                    lookup: "date__gte"
                }
            });

            filters.push({
                'id': 'fecha_fin',
                'value': {
                    input: fechaFin.format('YYYY-MM-DD'),
                    lookup: "date__lte"
                }
            });
        }

        if (cuentaCorriente != null) {
            filters.push({
                'id': 'cuenta_corriente_id',
                'value': {
                    input: cuentaCorriente.pk,
                    lookup: "exact"
                }
            });
        } else if (cuentaCorriente == null) {
            // Para que no se muestren filas en la tabla hasta que se seleccione
            // una Cuenta Corriente
            filters.push({
                'id': 'cuenta_corriente_id',
                'value': {
                    input: "-1",
                    lookup: "exact"
                }
            });
        }

        if (unidadVinculacionTecnologica != null) {
            filters.push({
                'id': 'unidad_vinculacion_tecnologica_id',
                'value': {
                    input: unidadVinculacionTecnologica.pk,
                    lookup: "exact"
                }
            });
        }

        return (
            <Fragment>
                <Row>
                    <Col md={4}>
                        <ParadigmaLabeledInput
                            labelColumns={6}
                            fieldColumns={6}
                            label={"Cuenta Corriente"}
                            inputComponent={
                                <ParadigmaAsyncSeeker
                                    nombreField={"subgrupo_nombre"}
                                    url={api.saldos.cuentasCorrientes.selectRestringido}
                                    value={cuentaCorriente ? cuentaCorriente.pk : null}
                                    onChange={this.onChangeCuentaCorriente}
                                />
                            }
                        />
                        <ParadigmaLabeledInput
                            labelColumns={6}
                            fieldColumns={6}
                            label={"UVT"}
                            inputComponent={
                                <ParadigmaAsyncSeeker
                                    fieldName={"unidad_vinculacion_tecnologica_filter"}
                                    url={api.proyectos.config.presupuesto.uvt.select}
                                    value={unidadVinculacionTecnologica ? unidadVinculacionTecnologica.pk : null}
                                    onChange={this.onChangeUnidadVinculacionTecnologica}
                                />
                            }
                        />
                    </Col>
                    <Col md={4}>
                        <ParadigmaLabeledInput
                            labelColumns={6}
                            fieldColumns={6}
                            label={"Inicio"}
                            inputComponent={
                                <ParadigmaDatePicker
                                    datetime={false}
                                    monthpicker={false}
                                    value={fechaInicio}
                                    onChange={(newFechaInicio) => this.onFechaChange(newFechaInicio, fechaFin)}
                                />
                            }
                        />
                        <ParadigmaLabeledInput
                            labelColumns={6}
                            fieldColumns={6}
                            label={"Fin"}
                            inputComponent={
                                <ParadigmaDatePicker
                                    datetime={false}
                                    monthpicker={false}
                                    value={fechaFin}
                                    onChange={(newfechaFin) => this.onFechaChange(fechaInicio, newfechaFin)}
                                />
                            }
                        />
                    </Col>
                    <Col md={4}>
                        <ParadigmaLabeledInput
                            labelColumns={6}
                            fieldColumns={6}
                            label={"Saldos UVT"}
                            inputComponent={
                                <div style={{ fontWeight: 800, textAlign: 'right', paddingTop: '7px' }}>
                                    {saldosUVT.length > 0 ? saldosUVT.map((saldo) => (
                                        <div key={saldo.pk}>{saldo.nombre}: ${formatCurrency(saldo.saldo)}</div>
                                    )) : <div><label>$</label>0</div>}
                                </div>
                            }
                        />
                    </Col>
                </Row>

                <ParadigmaTable
                    title={"Movimientos"}
                    buttons={buttons}
                    apiUrl={api.saldos.movimientos.list}
                    columns={columns}
                    exportUrl={api.saldos.movimientos.export}
                    outerFilter={filters}
                    onGetResponseData={this.setComponents}
                />
            </Fragment>
        );
    }
}

export default Contactos;



// WEBPACK FOOTER //
// ./src/views/Saldos/Movimientos/Movimientos.js